import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { RaisedButton, Dialog } from 'material-ui';
import connect from './connect';
import SuccessCheck from '../../../components/SuccessCheck';

const DeclineOrganizationInviteSuccessModal = ({ onClose, open }) => {
  const renderContent = () => (
    <Wrapper>
      <TitleContainer>
        <Title>Sent!</Title>
        <Description>Your decline organization invitation message was sent!</Description>
      </TitleContainer>
      <ImageContainer>
        <SuccessCheck style={{ width: '10rem', height: '10rem', margin: 0 }} />
      </ImageContainer>
      <ButtonsSection>
        <RaisedButton
          label="Close"
          onClick={onClose}
          buttonStyle={{ width: '12rem' }}
          primary
        />
      </ButtonsSection>
    </Wrapper>
  );

  return (
    <Dialog
      open={open}
      modal
      autoScrollBodyContent
    >
      {renderContent()}
    </Dialog>
  );
};

DeclineOrganizationInviteSuccessModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

DeclineOrganizationInviteSuccessModal.defaultProps = {
  onClose: () => {},
};

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
padding: 0 40px;
`;

const TitleContainer = styled.div`
  text-align: center;
  font-family: DIN-Medium;
`;

const Title = styled.div`
  font-size: 25px;
`;

const Description = styled.div`
  font-size: 20px;
  margin-top: 10px;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 4rem 0;
`;

const ButtonsSection = styled.div`
  width: 100%;
  margin-bottom: 3rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default connect(DeclineOrganizationInviteSuccessModal);
